import iconDependency from '@/dependencies/iconDependency'

const leftMenu = () => {
  const iconSvg = iconDependency()
  return [
    {
      name: 'BERANDA',
      items: [
        {
          icon: iconSvg.home,
          label: 'Dashboard',
          route: 'dashboard',
          items: [],
          prohibitedRoles: ['External']
        },
        {
          icon: iconSvg.home,
          label: 'Dashboard Roster',
          route: 'dashboard-roster',
          items: [],
          prohibitedRoles: ['Setoran', 'External', 'Adminkontrol']
        },
        {
          icon: iconSvg.report,
          label: 'Laporan',
          route: 'reports',
          prohibitedRoles: []
        }
      ],
      prohibitedRoles: []
    },
    {
      name: 'PERSIAPAN KEBERANGKATAN',
      items: [
        {
          icon: '<i class="pi pi-users"></i>',
          label: 'Master Kru',
          route: 'master-crew',
          prohibitedRoles: ['Setoran', 'Adminkontrol', 'External', 'Keuangan']
        },
        {
          icon: iconSvg.mandoran,
          label: 'Mandoran',
          route: 'master-mandoran',
          prohibitedRoles: ['Setoran', 'Adminkontrol', 'External', 'Keuangan']
        },
        {
          icon: iconSvg.masterRoute,
          label: 'Master Rute',
          route: 'master-route',
          prohibitedRoles: ['Roster', 'Setoran', 'Adminkontrol']
        },
        {
          icon: iconSvg.masterPrice,
          label: 'Master Harga & Komisi',
          route: 'master-price',
          prohibitedRoles: ['Roster', 'Setoran']
        },
        {
          icon: iconSvg.masterCommission,
          label: 'Master Komisi Mandoran',
          route: 'master-mandoran-commission',
          prohibitedRoles: ['Roster', 'Setoran']
        },
        {
          icon: iconSvg.masterExpenses,
          label: 'Master Pengeluaran',
          route: 'master-fixed-expenses',
          prohibitedRoles: ['Roster', 'Setoran']
        },
        {
          icon: iconSvg.masterTrayek,
          label: 'Master Trayek',
          route: null,
          items: [
            {
              label: 'Trayek Utama',
              route: 'master-trayek-main',
              prohibitedRoles: []
            },
            {
              label: 'Trayek Cadangan',
              route: 'master-trayek-reserve',
              prohibitedRoles: []
            },
            {
              label: 'Trayek Pariwisata',
              route: 'master-trayek-tourist',
              prohibitedRoles: []
            }
          ],
          prohibitedRoles: ['Roster', 'Setoran', 'Adminkontrol']
        },
        // plotting ditutup karena menunya digabung dengan roster
        // {
        //   icon: iconSvg.plotting,
        //   label: 'Ploting Kondektur',
        //   route: 'plotting-conductor',
        //   prohibitedRoles: ['Setoran', 'Adminkontrol']
        // },
        {
          icon: iconSvg.departureSchedule,
          label: 'Roster',
          route: 'roster',
          prohibitedRoles: ['Setoran', 'Adminkontrol']
        },
        {
          icon: iconSvg.airport,
          label: 'Bandara',
          route: null,
          items: [
            {
              label: 'Trayek Bandara',
              route: 'master-trayek-airport',
              prohibitedRoles: ['Roster']
            },
            {
              label: 'Roster Bandara',
              route: 'roster-airport',
              prohibitedRoles: []
            },
          ],
          prohibitedRoles: ['Roster', 'Setoran', 'Adminkontrol']
        },
        {
          icon: iconSvg.ticketBundle,
          label: 'Karcis Langganan',
          route: 'ticket-subscription',
          prohibitedRoles: ['Roster', 'External', 'Setoran', 'Adminkontrol']
        },
      ],
      prohibitedRoles: ['Setoran', 'External', 'Keuangan']
    },
    {
      name: 'TRANSAKSI',
      items: [
        {
          icon: iconSvg.approveDeposit,
          label: 'Approve Setoran',
          route: 'approve-deposits',
          prohibitedRoles: ['Roster', 'Adminkontrol']
        },
        {
          icon: iconSvg.reportVerbal,
          label: 'Laporan Verbal',
          route: 'verbal-report',
          prohibitedRoles: ['Roster', 'Setoran']
        },
        {
          icon: iconSvg.reportVerpal,
          label: 'Verpal',
          route: 'verpal-report',
          prohibitedRoles: ['Adminkontrol', 'Setoran']
        },
        {
          icon: iconSvg.location,
          label: 'Tracking Bus',
          route: 'tracking-bus',
          prohibitedRoles: ['Setoran']
        },
        {
          icon: iconSvg.closingStat,
          label: 'Closing Setoran',
          route: 'cashless-closed-deposits',
          prohibitedRoles: ['External', 'Roster', 'Adminkontrol']
        },
        {
          icon: iconSvg.approveSnack,
          label: 'Closing Snack',
          route: 'approve-snack',
          prohibitedRoles: ['External']
        },
      ],
      prohibitedRoles: ['External', 'Keuangan']
    },
    {
      name: 'EKSTERNAL',
      items: [
        {
          icon: iconSvg.partnerAgreement,
          label: 'Master Partner',
          route: 'master-partner',
          prohibitedRoles: ['Roster', 'Setoran', 'Keuangan'],
          items: []
        },
        {
          icon: iconSvg.fuelPump,
          label: 'Pom Bensin',
          route: null,
          items: [
            {
              label: 'Master Partner SPBU',
              route: 'master-spbu',
              prohibitedRoles: ['Setoran', 'Keuangan']
            },
            {
              label: 'Kupon BBM',
              route: 'master-fuel-coupon',
              prohibitedRoles: ['Setoran', 'Keuangan']
            },
            {
              label: 'Monitoring Transaksi',
              route: 'fuel-monitoring',
              prohibitedRoles: []
            },
            {
              label: 'Batch Pembayaran BBM',
              route: 'fuel-payment-batch',
              prohibitedRoles: []
            }
          ],
          prohibitedRoles: ['Roster', 'Adminkontrol']
        },
      ],
      prohibitedRoles: ['Roster', 'Adminkontrol', 'External']
    },
    {
      name: 'MASTER',
      items: [
        {
          icon: iconSvg.masterBank,
          label: 'Master Bank',
          route: 'master-bank',
          prohibitedRoles: []
        },
        // {
        //   icon: iconSvg.masterCredentialBank,
        //   label: 'Master ID Credential Bank',
        //   route: 'master-credential-bank',
        //   prohibitedRoles: []
        // },
        {
          icon: iconSvg.Helper,
          label: 'Master Mitra Agen',
          route: 'master-partner-agent',
          prohibitedRoles: []
        },
        {
          icon: iconSvg.masterVehicle,
          label: 'Master Kendaraan',
          route: 'master-vehicle',
          prohibitedRoles: []
        },
        {
          icon: iconSvg.masterCity,
          label: 'Master Kota & Terminal',
          route: 'master-city-terminal',
          prohibitedRoles: []
        },
        {
          icon: iconSvg.masterPassengerType,
          label: 'Master Jenis Penumpang',
          route: 'master-passenger-type',
          prohibitedRoles: []
        },
        {
          icon: iconSvg.masterConstraint,
          label: 'Master Jenis Kendala',
          route: 'master-constraint-type',
          prohibitedRoles: []
        },
        {
          icon: iconSvg.masterClass,
          label: 'Master Kelas',
          route: 'master-class',
          prohibitedRoles: []
        },
        {
          icon: iconSvg.snack,
          label: 'Master Snack',
          route: 'master-snack',
          prohibitedRoles: []
        },
      ],
      prohibitedRoles: ['Roster', 'Setoran', 'Adminkontrol', 'External', 'Keuangan']
    },
    {
      name: 'SETTINGS',
      items: [
        {
          icon: iconSvg.globalSettings,
          label: 'Global Settings',
          route: 'global-settings',
          prohibitedRoles: []
        },
      ],
      prohibitedRoles: ['Roster', 'Setoran', 'Adminkontrol', 'External', 'Keuangan']
    },
    {
      name: 'SUPPORT',
      items: [
        {
          icon: iconSvg.support,
          label: 'Pusat Bantuan',
          route: 'helpdesk',
          prohibitedRoles: []
        },
      ],
      prohibitedRoles: ['Setoran', 'Adminkontrol', 'External', 'Keuangan']
    }
  ]
}

export default leftMenu
